import React from 'react'
import { cn } from '../../lib/utils'

export interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string
  error?: string
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, error, checked, onChange, disabled, id, ...props }, ref) => {
    const checkboxId = id || `checkbox-${Math.random().toString(36).substr(2, 9)}`

    return (
      <div className="space-y-2">
        <div className="flex items-center space-x-3">
          <input
            type="checkbox"
            id={checkboxId}
            checked={checked}
            onChange={onChange}
            disabled={disabled}
            className={cn(
              'w-4 h-4 rounded border-2 transition-colors focus:outline-none',
              error && 'border-red-500',
              className
            )}
            style={{
              backgroundColor: checked ? 'var(--color-accent)' : 'var(--color-bg-primary)',
              borderColor: error ? 'var(--color-error, #ef4444)' : checked ? 'var(--color-accent)' : 'var(--color-border)',
              ...(disabled && {
                opacity: 0.5,
                cursor: 'not-allowed'
              })
            } as React.CSSProperties}
            ref={ref}
            aria-invalid={error ? 'true' : undefined}
            aria-describedby={error ? `${checkboxId}-error` : undefined}
            {...props}
          />
          {label && (
            <label
              htmlFor={checkboxId}
              className="text-sm font-medium cursor-pointer"
              style={{
                color: 'var(--color-text-primary)',
                ...(disabled && {
                  cursor: 'not-allowed',
                  opacity: 0.5
                })
              }}
            >
              {label}
            </label>
          )}
        </div>
        {error && (
          <p id={`${checkboxId}-error`} className="text-sm" style={{ color: 'var(--color-error, #ef4444)' }}>
            {error}
          </p>
        )}
      </div>
    )
  }
)

Checkbox.displayName = 'Checkbox'

export { Checkbox }

